export default __webpack_public_path__ + "static/char-thumb-17-513064cdf8cb2543adbbef9cef7aa367.png";